import { Order } from "../Models/Order";
import { Product } from "../Models/Product";
import { getApi, postApi } from "./Api";

export const createOrder = async (obj:any) => {
    try{
        return await postApi<{message:string}>('orders', obj)
    }
    catch(error){
        throw error;
    }
}

export const getOrdersAdmin = async (page?:number, limit?:number, status?:string) => {
    try{
        return await getApi<{orders:Order[], last_page:number, page:number, total:number}>(`orders/admin-orders?page=${page || 1}&limit=${limit || 10}&status=${status || ""}`)
    }
    catch(error){
        throw error;
    }
}

export const getOrderAdminByID = async (id?:string) => {
    try{
        return await getApi<Order>(`orders/admin-orders/${id}`)
    }
    catch(error){
        throw error;
    }
}